<footer *ngIf="!hideNavigation">
  <div class="circle-button pointer" (click)="scrollToTop()">
    <img src="assets/images/icons/arrow-up-white.svg" alt="" />
  </div>

  <div class="main-footer w-full">
    <div class="container footer-wrapper w-full">
      <div class="footer-info">
        <img src="assets/images/logo-white.svg" alt="" class="logo" />
        <div class="flex footer-details">
          <div class="left-content">
            <p class="description">
              <a href="https://kingiftcard.com">Kingiftcard.com</a> lets you buy
              gift cards with crypto easily and securely. Shop top brands like
              Amazon, Apple, PlayStation, and Steam — delivered fast via email.
              No bank needed — just crypto.
            </p>
          </div>
          <div class="links-container">
            <h4 class="content-title">Links</h4>
            <div class="links">
              <a href="/">Home</a>
              <a [routerLink]="['/category/all']">Categories</a>
              <a [routerLink]="['/pages', 'contact-us']">Contact Us</a>
            </div>
          </div>
          <div class="social-info">
            <h4 class="content-title">Follow Us On Social Media</h4>
            <div class="social-icons">
              <a href="https://instagram.com/king_giftcard/" target="_blank"
                ><img src="assets/images/icons/instagram.svg" alt="Instagram"
              /></a>
              <a href="https://t.me/kingiftcard" target="_blank">
                <img src="assets/images/icons/telegram.svg" alt="Telegram" />
              </a>
              <a
                href="https://www.linkedin.com/company/king-gift-card/"
                target="_blank"
              >
                <img src="assets/images/icons/linkedin.svg" alt="Linkedin" />
              </a>
              <a href="https://x.com/kingiftcard" target="_blank">
                <img src="assets/images/icons/x.svg" alt="X" />
              </a>
              <a href="https://facebook.com/kingiftcard" target="_blank"
                ><img src="assets/images/icons/facebook.svg" alt="Facebook" />
              </a>
              <a href="https://www.threads.com/@king_giftcard" target="_blank"
                ><img src="assets/images/icons/threads.svg" alt="Threads" />
              </a>
            </div>
          </div>

          <!-- <div class="change-mode-wrapper">
            <h4 class="content-title">Change Mode</h4>
            <div class="change-mode-switch">
              <button [class.active]="isLightMode" (click)="isLightMode = true">
                <img
                  src="{{
                    isLightMode ? icons.LightModeActive : icons.LightMode
                  }}"
                  alt="light mode button"
                />
                <span>Light</span>
              </button>
              <button
                [class.active]="!isLightMode"
                (click)="isLightMode = false"
              >
                <img
                  src="{{
                    isLightMode ? icons.DarkMode : icons.DarkModeActive
                  }}"
                  alt="dark mode button"
                />
                <span>Dark</span>
              </button>
            </div>
          </div> -->
        </div>
      </div>
      <div class="footer-description flex">
        <div class="info">
          <a [routerLink]="['/pages', 'cookie-policy']">Cookie</a>
          <a [routerLink]="['/pages', 'privacy-policy']" class="dot-link"
            >Privacy Policy</a
          >
          <a [routerLink]="['/pages', 'return-policy']" class="dot-link"
            >Return Policy</a
          >
        </div>
        <p class="rights-detail">
          All Rights Are Reserved For
          <a href="https://kingiftcard.com">Kingiftcard</a>
        </p>
      </div>
    </div>
  </div>
</footer>
